import React from "react";
import { Skeleton } from "app/components/Skeleton";

type AttachmentPreviewSkeletonProps = {
  zoomLevel?: number;
};

const AttachmentPreviewSkeleton: React.FC<AttachmentPreviewSkeletonProps> = ({
  zoomLevel = 100,
}) => {
  void zoomLevel;

  return (
    <main className="h-full min-h-0 w-full bg-gray-100 overflow-auto">
      <div className="h-full w-full flex items-center justify-center p-6">
        {/* Middle panel layout (from the design spec) */}
        <div className="w-[580px] bg-white rounded-[4px] border border-gray-100 opacity-100">
          <div className="p-6 space-y-6">
          {/* Top row: left rectangles + right 4 rectangles */}
          <div className="flex gap-10">
            <div className="flex flex-col gap-6">
              <Skeleton className="w-[220px] h-[48px] rounded-[2px]" />
              <Skeleton className="w-[220px] h-[48px] rounded-[2px]" />
            </div>
            <div className="flex flex-col gap-4">
              <Skeleton className="w-[240px] h-[14px] rounded-[2px]" />
              <Skeleton className="w-[240px] h-[14px] rounded-[2px]" />
              <Skeleton className="w-[240px] h-[14px] rounded-[2px]" />
              <Skeleton className="w-[240px] h-[14px] rounded-[2px]" />
            </div>
          </div>

          {/* Small middle rectangle */}
          <div className="flex justify-center">
            <Skeleton className="w-[230px] h-[34px] rounded-[2px]" />
          </div>

          {/* Wide rectangle + wide rectangle with X */}
          <div className="space-y-6">
            <Skeleton className="w-full h-[110px] rounded-[2px]" />

            <Skeleton className="w-full h-[110px] rounded-[2px]" />
          </div>

          {/* Bottom row: left big rectangle + right 2 rectangles */}
          <div className="flex gap-10">
            <Skeleton className="w-[260px] h-[105px] rounded-[2px]" />
            <div className="flex flex-col gap-6">
              <Skeleton className="w-[220px] h-[48px] rounded-[2px]" />
              <Skeleton className="w-[220px] h-[48px] rounded-[2px]" />
            </div>
          </div>

          {/* Extra wide rectangles (bottom area) */}
          <div className="space-y-6">
            <Skeleton className="w-full h-[82px] rounded-[2px]" />
            <Skeleton className="w-full h-[82px] rounded-[2px]" />
          </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default AttachmentPreviewSkeleton;

